import { StatusChip } from "@/components/StatusChip";
import { Column } from "@/constants/pipeline";
import { CircleCheck2Icon } from "@/icons";
import { WIPModel } from "@/models/pipeline";
import { ApplicationDropdown } from "./ApplicationDropdown";
import { FirstColumnContent } from "./FirstColumnContent";
import { Row } from "./Row";
import { RowContent } from "./RowContent";

export type WIPRowProps = {
  data: WIPModel;
  agentId: number;
  columns: Column[];
  isPinned: boolean;
  isDepartmentView?: boolean;
  onAgentNameClick?: (agentName: string) => void;
  onTogglePin: (id: string) => void;
};

export const WIPRow = ({
  data,
  agentId,
  columns,
  isPinned,
  isDepartmentView = false,
  onAgentNameClick,
  onTogglePin,
}: WIPRowProps) => {
  const hasAgentColumn = columns.some((column) => column.key === "allocatedAgentName");

  return (
    <Row id={data.customerName} data={data}>
      <RowContent
        columns={columns}
        children={[
          <FirstColumnContent
            itemId={data.applicationId?.toString() || ""}
            agentId={agentId}
            isPinned={isPinned}
            handoverAllocatedUserId={data.handoverAllocatedUserId}
            handoverToUserId={data.handoverToUserId}
            customerName={data.customerName}
            onTogglePin={onTogglePin}
            isDepartmentView={isDepartmentView}
          />,
          ...(hasAgentColumn
            ? [
                <span
                  className={
                    data.allocatedAgentName && onAgentNameClick
                      ? "cursor-pointer truncate underline transition-opacity hover:opacity-70"
                      : ""
                  }
                  onClick={(e) => {
                    if (data.allocatedAgentName && onAgentNameClick) {
                      e.stopPropagation();
                      onAgentNameClick(data.allocatedAgentName);
                    }
                  }}
                >
                  {data.allocatedAgentName}
                </span>,
              ]
            : []),
          <span>{data.isPredictedToPay ? <CircleCheck2Icon /> : null}</span>,
          <span className="truncate">{data.allocatedPayoutAgent}</span>,
          <span className="truncate" title={data.status}>
            {data.status}
          </span>,
          <StatusChip status={data.customerDocsStatus} hideIcon fullWidth className="!py-px" />,
          <StatusChip status={data.dealerDocsStatus} hideIcon fullWidth className="!py-px" />,
          <StatusChip status={data.financeDocsStatus} hideIcon fullWidth className="!py-px" />,
          <ApplicationDropdown
            applicationId={data.applicationId?.toString()}
            isPinned={isPinned}
            isDepartmentView={isDepartmentView}
            onTogglePin={onTogglePin}
          />,
        ]}
      />
    </Row>
  );
};
